import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { finalize } from "rxjs";
import { TfSharedListService } from "@app/modules/tf-shared-list";
import { TfNotificationsService } from "@app/modules/tf-notifications";
import { TfUserDataService } from "@app/modules/tf-user-data";
import { SaveToListType } from "@app/modules/tf-shared-list/models/types/save-to-list.type";
import { SharedListType } from "@app/modules/tf-shared-list/models/types/shared-list.type";

@Component({
    selector: 'tf-shared-list-popper',
    templateUrl: './tf-shared-list-popper.component.html',
    styleUrls: ['./tf-shared-list-popper.component.scss']
})
export class TfSharedListPopperComponent implements OnInit {

    @Input() assay: SaveToListType;
    @Output() onItemAddedToList: EventEmitter<SaveToListType> = new EventEmitter<SaveToListType>();

    visible: boolean = false;
    initialLoad: string = null;

    showLoading: boolean = false;
    showListsContainer: boolean = false;
    doneLoading: boolean = false;

    newListName: string;
    shareList: SharedListType[] = [];

    constructor(
        private userDataService: TfUserDataService,
        private sharedListService: TfSharedListService,
        private tfNotificationsService: TfNotificationsService
    ) {

    }

    ngOnInit(): void {
        this.loadSaveToList();
    }

    loadSaveToList() {

        this.showLoading = true;

        this.sharedListService.getSharedList()
            .pipe(finalize(() => {
                this.showLoading = false;
                this.showListsContainer = true;
            }))
            .subscribe({
                next: data => {
                    this.shareList = data;
                },
                error: err => {
                    console.error(err);
                    this.tfNotificationsService.showErrorHtml('There has been an error, please try again later.', 'Error',
                        {toastClass: 'availability-notification', timeOut: 10000, extendedTimeOut: 10000}
                    );
                }
            });

    }

    isLoggedIn(): boolean {
        return this.userDataService.getIsLoggedInValue();
    }

    addToNewSharedList($event) {

        $event.stopPropagation();

        this.showLoading = true;
        this.showListsContainer = false;

        if (this.validateNewListNameHasNoSpecialChars(this.newListName)) {
            this.sharedListService.addToNewSharedList(this.newListName, this.assay)
                .pipe(
                    finalize(() => {
                        this.showLoading = false;
                        this.showListsContainer = true;
                    })
                )
                .subscribe({
                        next: (response) => {
                            if (response.status === 'ACCEPTED') {
                                this.shareList = response.userSharedLists;
                                this.loadSaveToList();
                                this.newListName = null;
                                this.onItemAddedToList.emit(this.assay);
                            }
                        },
                        error: (err) => {
                            console.error(err);
                            this.tfNotificationsService.showErrorHtml('There has been an error, please try again later.', 'Error',
                                {toastClass: 'availability-notification', timeOut: 10000, extendedTimeOut: 10000}
                            );
                        }
                    }
                )
        }
    }

    addToExistingSharedList($event: MouseEvent, listItem: SharedListType) {

        $event.stopPropagation();

        this.showLoading = true;
        this.showListsContainer = false;

        this.sharedListService.addToExistingSharedList(listItem, this.assay)
            .pipe(
                finalize(() => {
                    this.showLoading = false;
                    this.showListsContainer = true;
                }))
            .subscribe({

                next: response => {

                    if (response.status === 'ACCEPTED') {
                        this.onItemAddedToList.emit(this.assay);
                    }

                },
                error: err => {
                    console.error(err);
                    this.showLoading = false;
                    this.showListsContainer = true;
                    this.tfNotificationsService.showErrorHtml('There has been an error, please try again later.', 'Error',
                        {toastClass: 'availability-notification', timeOut: 10000, extendedTimeOut: 10000}
                    );

                }

            })

    }

    validateNewListNameHasNoSpecialChars(listName) {

        listName = listName.replace(/^\s+/, function (m) {
            return m.replace(/\s/g, '');
        });

        return !((listName.match(/[?/%^!]+/)) || (listName.match(/\\/)));

    }


}
